import axios from 'axios';

export type StandardApiError = {
  message: string;
  status?: number;
  code?: string;
  details?: unknown;
};

export const normalizeApiError = (error: unknown, fallback = 'Wystąpił błąd'): StandardApiError => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: string; error?: string; code?: string; details?: unknown } | undefined;
    return {
      message: data?.message || data?.error || error.message || fallback,
      status: error.response?.status,
      code: data?.code || error.code,
      details: data?.details || data
    };
  }

  if (error instanceof Error) {
    return { message: error.message || fallback };
  }

  if (typeof error === 'string') {
    return { message: error || fallback };
  }

  return { message: fallback, details: error };
};

export const getApiErrorMessage = (error: unknown, fallback = 'Wystąpił błąd') =>
  normalizeApiError(error, fallback).message;
